"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* global require */
require("src/polyfill");
var React = require("react");
var ThemeProvider_1 = require("@material-ui/styles/ThemeProvider");
var history_1 = require("history");
var react_apollo_1 = require("react-apollo");
var react_dom_1 = require("react-dom");
var react_router_1 = require("react-router");
var redux_1 = require("redux");
var seamless_immutable_1 = require("seamless-immutable");
var ApolloClient_1 = require("src/ApolloClient");
var ApplicationStore_1 = require("src/ApplicationStore");
var BasePage_1 = require("src/BasePage");
var Products_1 = require("src/bookstore/Products");
var SiteHeader_1 = require("src/bookstore/SiteHeader");
var theme_1 = require("src/bookstore/theme");
var EnvSettings_1 = require("src/components/EnvSettings");
var ScrollToTop_1 = require("src/components/ScrollToTop");
var CurrentUser_1 = require("src/CurrentUser");
var Env_1 = require("src/Env");
var loadEnv_1 = require("src/Env/loadEnv");
var ErrorBoundary_1 = require("src/ErrorBoundary");
var Login_1 = require("src/Login");
var Telemetry_1 = require("src/Telemetry");
var Bookshelf_1 = require("./Bookshelf");
var Cart_1 = require("./Cart");
var IndexPage_1 = require("./IndexPage");
var SiteFooter_1 = require("./SiteFooter");
var UserAccounts_1 = require("./UserAccounts");
var UserCart_1 = require("./UserCart");
var history = history_1.createBrowserHistory({
    basename: Env_1.BOOKSTORE_ROUTER_BASE_NAME
});
var applicationStore = redux_1.createStore(function () { return ({
    featureFlags: seamless_immutable_1.from({})
}); });
Telemetry_1.Sentry.init('bookstore');
var env = loadEnv_1.default();
var App = function () { return (React.createElement(ApplicationStore_1.Provider, { store: applicationStore },
    React.createElement(ThemeProvider_1.default, { theme: theme_1.default },
        React.createElement(react_apollo_1.ApolloProvider, { client: ApolloClient_1.apolloClient },
            React.createElement(react_router_1.Router, { history: history },
                React.createElement(ScrollToTop_1.ScrollToTop, null,
                    React.createElement(ErrorBoundary_1.ErrorBoundary, null,
                        React.createElement(CurrentUser_1.CurrentUser, null,
                            React.createElement(UserCart_1.UserCart, null,
                                React.createElement(SiteHeader_1.default, null),
                                React.createElement(BasePage_1.BasePage, null,
                                    React.createElement(react_router_1.Route, { path: "/", component: IndexPage_1.default, exact: true }),
                                    React.createElement(react_router_1.Route, { path: "/library/", component: Bookshelf_1.BookshelfPage, exact: true }),
                                    React.createElement(react_router_1.Route, { path: "/login/", component: Login_1.LogInPage, exact: true }),
                                    React.createElement(react_router_1.Route, { path: "/login/:aliasUUID", component: Login_1.LogInPage, exact: true }),
                                    React.createElement(react_router_1.Route, { path: "/logOut/", component: UserAccounts_1.LogOutPage, exact: true }),
                                    React.createElement(react_router_1.Route, { path: "/signup/", component: UserAccounts_1.SignupPage, exact: true }),
                                    React.createElement(react_router_1.Route, { path: "/editUser/", component: UserAccounts_1.EditUserPage, exact: true }),
                                    React.createElement(react_router_1.Route, { path: "/resetPassword/", component: UserAccounts_1.ResetPasswordPage, exact: true }),
                                    React.createElement(react_router_1.Route, { path: "/updatePassword/", component: UserAccounts_1.UpdatePasswordPage, exact: true }),
                                    React.createElement(react_router_1.Route, { path: "/resendConfirmation/", component: UserAccounts_1.ResendConfirmationPage, exact: true }),
                                    React.createElement(react_router_1.Route, { path: "/confirmation/", component: UserAccounts_1.ConfirmationPage, exact: true }),
                                    React.createElement(react_router_1.Route, { path: "/products/", component: Products_1.ProductIndexPage, exact: true }),
                                    React.createElement(react_router_1.Route, { path: "/products/:slug", component: Products_1.ProductShowPage, exact: true }),
                                    React.createElement(react_router_1.Route, { path: "/cart/", component: Cart_1.CartPage, exact: true }),
                                    React.createElement(react_router_1.Route, { path: "/cart/checkout/", component: Cart_1.CheckoutPage, exact: true })),
                                env.NAME === 'usni' && React.createElement(SiteFooter_1.USNISiteFooter, null))))))),
        React.createElement(EnvSettings_1.EnvSettings, null)))); };
react_dom_1.render(React.createElement(App, null), document.getElementById('root'));
